export default function () {
    const CHOICE_SECONDAIRE_I = 1;
    const CHOICE_GYMNASE = 2;
    const CHOICE_ECOLE_DE_CULTURE_GENERALE = 3;
    const CHOICE_APPRENTISSAGE_DUAL = 4;
    const CHOICE_APPRENTISSAGE_EN_ECOLE = 5;
    const CHOICE_AUTRE_FORMATION_EN_COURS = 6;
    const CHOICE_FORMATION_ACHEVEE = 7;

    const cantonElementSelector = '#item-id-100';
    const formationEnCoursElementSelector = '#item-id-110';
    const degreElementSelector = '#item-id-120';
    const professionElementSelector = "#item-id-130";
    const sectionVoieNiveauElementSelector = "#item-id-140";
    const optionFiliereElementSelector = "#item-id-150";
    const optionElementSelector = "#item-id-160";
    const nomDeLaFormationProfessionElementSelector = '#item-id-170';
    const professionDiplomeElementSelector = '#item-id-180';
    const remarqueElementSelector = '#item-id-190';

    const submitButtonSelector = '.sl-js-survey-page-form button:submit';
    const errorMessageSelector = '.js-answer-list .js-sl-alert-danger';

    const degreOptions: Array<string[]> = [];

    $(degreElementSelector + ' > option').each(function () {
        const text = $(this).text();
        const val = <string>$(this).val();
        degreOptions.push([text, val]);
    });

    $(cantonElementSelector).on('change', function () {
        if (parseInt(<string>$(this).val()) > 0) {
            showFormationEnCours();
        } else {
            // Hide all
            hideAndResetFormationEnCours();
            hideAndResetDegre();
            hideAndResetSectionVoieNiveau();
            hideAndResetOption();
            hideAndResetOptionFiliere();
            hideAndResetProfession();
            hideAndResetNomDeLaFormationProfession();
            hideAndResetProfessionDiplome();
            hideAndResetRemarque();
        }
        if (isErrorMessageShown()) {
            hideErrorMessage();
        }
    });

    $(formationEnCoursElementSelector).on('change', function () {
        const formationEnCoursValue = parseInt(<string>$(this).val());
        switch (formationEnCoursValue) {
            case CHOICE_SECONDAIRE_I:
            case CHOICE_GYMNASE:
            case CHOICE_ECOLE_DE_CULTURE_GENERALE:
            case CHOICE_APPRENTISSAGE_DUAL:
            case CHOICE_APPRENTISSAGE_EN_ECOLE:
                resetAndShowDegre();
                hideAndResetSectionVoieNiveau();
                hideAndResetOption();
                hideAndResetOptionFiliere();
                hideAndResetProfession();
                hideAndResetNomDeLaFormationProfession();
                hideAndResetProfessionDiplome();
                hideAndResetRemarque();
                break;
            case CHOICE_AUTRE_FORMATION_EN_COURS:
                hideAndResetDegre();
                hideAndResetSectionVoieNiveau();
                hideAndResetOption();
                hideAndResetOptionFiliere();
                hideAndResetProfession();
                showNomDeLaFormationProfession();
                hideAndResetProfessionDiplome();
                showRemarque();
                break;
            case CHOICE_FORMATION_ACHEVEE:
                hideAndResetDegre();
                hideAndResetSectionVoieNiveau();
                hideAndResetOption();
                hideAndResetOptionFiliere();
                hideAndResetProfession();
                hideAndResetNomDeLaFormationProfession();
                showProfessionDiplome();
                showRemarque();
                break;
            default:
                hideAndResetDegre();
                hideAndResetSectionVoieNiveau();
                hideAndResetOption();
                hideAndResetOptionFiliere();
                hideAndResetProfession();
                hideAndResetNomDeLaFormationProfession();
                hideAndResetProfessionDiplome();
                hideAndResetRemarque();
        }
        if (isErrorMessageShown()) {
            hideErrorMessage();
        }
    });

    $(degreElementSelector).on('change', function () {
        if (parseInt(<string>$(this).val()) > 0) {
            const formationEnCoursValue = parseInt(<string>$(formationEnCoursElementSelector).val());
            switch (formationEnCoursValue) {
                case CHOICE_SECONDAIRE_I:
                    showSectionVoieNiveau();
                    showRemarque();
                    break;
                case CHOICE_GYMNASE:
                    showOption();
                    showRemarque();
                    break;
                case CHOICE_ECOLE_DE_CULTURE_GENERALE:
                    showOptionFiliere();
                    showRemarque();
                    break;
                case CHOICE_APPRENTISSAGE_DUAL:
                case CHOICE_APPRENTISSAGE_EN_ECOLE:
                    showProfession();
                    showRemarque();
                    break;
                default:
                    hideAndResetSectionVoieNiveau();
                    hideAndResetOption();
                    hideAndResetOptionFiliere();
                    hideAndResetProfession();
            }
        }
        if (isErrorMessageShown()) {
            hideErrorMessage();
        }
    });

    $(submitButtonSelector).on('click', function (event) {
        if (!areRequiredFieldsValid()) {
            event.preventDefault();
            showErrorMessage();
        }
    });

    /**
     * Shows the row with the element "Formation en cours".
     */
    function showFormationEnCours() {
        showElement(formationEnCoursElementSelector);
    }

    /**
     * Hides the row with the element "Formation en cours".
     */
    function hideAndResetFormationEnCours() {
        hideElement(formationEnCoursElementSelector);
        $(formationEnCoursElementSelector).val(-1);
    }

    /**
     * Resets the value and shows the row of the element "Degré".
     */
    function resetAndShowDegre() {
        $(degreElementSelector).val(-1);
        const formationEnCoursValue = parseInt(<string>$(formationEnCoursElementSelector).val());
        // Remove all options
        $(degreElementSelector + ' > option').remove();
        // Append options that are needed
        $(degreElementSelector).append(new Option(degreOptions[0][0], degreOptions[0][1]));
        if (formationEnCoursValue == CHOICE_SECONDAIRE_I) {
            $(degreElementSelector).append(new Option(degreOptions[5][0], degreOptions[5][1]));
            $(degreElementSelector).append(new Option(degreOptions[6][0], degreOptions[6][1]));
            $(degreElementSelector).append(new Option(degreOptions[7][0], degreOptions[7][1]));
        } else {
            $(degreElementSelector).append(new Option(degreOptions[1][0], degreOptions[1][1]));
            $(degreElementSelector).append(new Option(degreOptions[2][0], degreOptions[2][1]));
            $(degreElementSelector).append(new Option(degreOptions[3][0], degreOptions[3][1]));
            $(degreElementSelector).append(new Option(degreOptions[4][0], degreOptions[4][1]));
        }
        showElement(degreElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Degré".
     */
    function hideAndResetDegre() {
        hideElement(degreElementSelector);
        $(degreElementSelector).val(-1);
    }

    /**
     * Shows the row with the element "Profession".
     */
    function showProfession() {
        showElement(professionElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Profession".
     */
    function hideAndResetProfession() {
        hideElement(professionElementSelector);
        $(professionElementSelector).val('');
    }

    /**
     * Shows the row with the element "Section / voie / niveau".
     */
    function showSectionVoieNiveau() {
        showElement(sectionVoieNiveauElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Section / voie / niveau".
     */
    function hideAndResetSectionVoieNiveau() {
        hideElement(sectionVoieNiveauElementSelector);
        $(sectionVoieNiveauElementSelector).val('');
    }

    /**
     * Shows the row with the element "Option / filière".
     */
    function showOptionFiliere() {
        showElement(optionFiliereElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Option / filière".
     */
    function hideAndResetOptionFiliere() {
        hideElement(optionFiliereElementSelector);
        $(optionFiliereElementSelector).val('');
    }

    /**
     * Shows the row with the element "Option".
     */
    function showOption() {
        showElement(optionElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Option".
     */
    function hideAndResetOption() {
        hideElement(optionElementSelector);
        $(optionElementSelector).val('');
    }

    /**
     * Shows the row with the element "Nom de la formation / profession".
     */
    function showNomDeLaFormationProfession() {
        showElement(nomDeLaFormationProfessionElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Nom de la formation / profession".
     */
    function hideAndResetNomDeLaFormationProfession() {
        hideElement(nomDeLaFormationProfessionElementSelector);
        $(nomDeLaFormationProfessionElementSelector).val('');
    }

    /**
     * Shows the row with the element "Profession / diplôme".
     */
    function showProfessionDiplome() {
        showElement(professionDiplomeElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Profession / diplôme".
     */
    function hideAndResetProfessionDiplome() {
        hideElement(professionDiplomeElementSelector);
        $(professionDiplomeElementSelector).val('');
    }

    /**
     * Shows the row with the element "Remarque".
     */
    function showRemarque() {
        showElement(remarqueElementSelector);
    }

    /**
     * Hides the row and resets the value of the element "Remarque".
     */
    function hideAndResetRemarque() {
        hideElement(remarqueElementSelector);
        $(remarqueElementSelector).val('');
    }

    /**
     * Shows the elements container in which the given element is contained.
     */
    function showElement(elementSelector: string): void {
        $(elementSelector).parents(".sl-survey-element-container").css('display', 'block');
    }

    /**
     * Hides the elements container in which the given element is contained.
     */
    function hideElement(elementSelector: string): void {
        $(elementSelector).parents(".sl-survey-element-container").css('display', 'none');
    }

    /**
     * Returns whether the error message is shown.
     */
    function isErrorMessageShown(): boolean {
        return $(errorMessageSelector).css('display') === 'block';
    }

    /**
     * Hides the error message.
     */
    function hideErrorMessage(): void {
        $(errorMessageSelector).css('display', 'none');
    }

    /**
     * Shows the error message.
     */
    function showErrorMessage(): void {
        $(errorMessageSelector).css('display', 'block');
    }

    /**
     * Returns whether all required fields are valid.
     */
    function areRequiredFieldsValid(): boolean {
        if ($(cantonElementSelector).val() < 1 ||
            $(formationEnCoursElementSelector).val() < 1) {
            return false;
        } else if (hasValidInput($(professionElementSelector), true) ||
            hasValidInput($(sectionVoieNiveauElementSelector), true) ||
            hasValidInput($(optionFiliereElementSelector), true) ||
            hasValidInput($(optionElementSelector), true) ||
            hasValidInput($(nomDeLaFormationProfessionElementSelector), true) ||
            hasValidInput($(professionDiplomeElementSelector), true)) {
            return hasValidInput($(remarqueElementSelector), false);
        }
        return false;
    }

    /**
     * Returns whether the given element has an valid input.
     */
    function hasValidInput($element: JQuery<HTMLElement>, isRequired: boolean): boolean {
        const val = (<string>$element.val()).trim();
        return !isRequired || val.length > 0;
    }
}